import Cookies from 'universal-cookie';
import { Box } from '@chakra-ui/react';
import moment from 'moment';

import FilterSearch from 'UiKit/search';
import FilterDateRangePickerMobile from 'UiKit/filter-date-range-picker-mobile';

import { useHostScheduleState } from 'View/host-schedule/state';
import getEndDayWithTimeZone from 'View/host-schedule/helper/getEndDayWithTimezone';
import getStartDayWithTimeZone from 'View/host-schedule/helper/getStartDayWithTimezone';
import getDateConstraint from 'View/host-schedule/helper/getDateConstraint';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

const FilterList = () => {
  const { t } = useTranslation('host-schedule');
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  const { filterState, updateFilterState } = useHostScheduleState();
  const { startDate, endDate } = filterState;

  const onChangeSearch = (value) => updateFilterState({ search: value, page: 1 });
  const onChangeDateRange = ({ startDate, endDate }) => {
    const newStartDate = getStartDayWithTimeZone(startDate);
    const newEndDate = getEndDayWithTimeZone(endDate);

    updateFilterState({ startDate: newStartDate, endDate: newEndDate, page: 1 });
  };

  const dateConstraint = getDateConstraint();

  const selectedStartDate = moment.tz(startDate, timezone).format('YYYY-MM-DD');
  const selectedEndDate = moment.tz(endDate, timezone).format('YYYY-MM-DD');

  return (
    <Box className={styles['filter__container']}>
      <Box className={styles['filter__item']} flex={1}>
        <FilterSearch className={styles['filter-search']} placeholder={t('filter.search')} variant="outlined" icon="search" onSearch={onChangeSearch} />
      </Box>

      <Box className={styles['filter__item']}>
        <FilterDateRangePickerMobile
          minDate={dateConstraint?.minDate}
          maxDate={dateConstraint?.maxDate}
          startDate={selectedStartDate}
          endDate={selectedEndDate}
          onChange={onChangeDateRange}
        />
      </Box>
    </Box>
  );
};

export default FilterList;
